import { THEME_COLOR } from "../../../../styles/colors";
import Box from "@amzn/meridian/esm/components/box";
import Column from "@amzn/meridian/esm/components/column";
import ProgressTracker, { ProgressTrackerStep } from "@amzn/meridian/esm/components/progress-tracker";
import Text from "@amzn/meridian/esm/components/text";
import Theme from "@amzn/meridian/esm/components/theme";

const STATUS_MAP = {
  done: "past",
  active: "present",
  pending: "future",
};

const TimelineCard = ({ title, events }) => {
  return (
    <Theme tokens={{
      boxBorderColorOutline: THEME_COLOR.MIST_GRAY,
      boxBorderRadiusOutline: 12,
      progressTrackerTextDefaultForegroundColor: THEME_COLOR.MID_GRAY,
      progressTrackerTextDefaultFontSize: "12px",
      progressTrackerSpacingSmall: "0px"
    }}>
      <Box type="outline" spacingInset="400">
        <Column spacing="300">
          {title && <Text type="h100">{title}</Text>}
          <ProgressTracker direction="column" compact>
            {Array.isArray(events) && events.map((event, i) => (
              <ProgressTrackerStep
                key={i}
                type={STATUS_MAP[event.status] || "future"}
                label={event.time || ""}
                showLabel
              >
                <Column spacing="none">
                  {event.label && <Text type="h50">{event.label}</Text>}
                  {event.description && <Text type="b200" color="secondary">{event.description}</Text>}
                </Column>
              </ProgressTrackerStep>
            ))}
          </ProgressTracker>
        </Column>
      </Box>
    </Theme>
  );
};

export default TimelineCard;
